import React from "react";
import { StyledSVG } from "../styled";
import { sizes } from "../options";

const ChevronRight = ({ variant, size, className }) => (
  <StyledSVG
    variant={variant}
    className={className}
    size={size}
    viewBox={`0 0 ${sizes[size].width.split("p")[0]} ${sizes[size].height.split("p")[0]}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.21966 15.1553C5.92677 14.8625 5.92677 14.3876 6.21966 14.0947L11.2578 9.05655L6.21966 4.01841C5.92677 3.72551 5.92677 3.25064 6.21966 2.95775C6.51256 2.66485 6.98743 2.66485 7.28032 2.95775L12.8488 8.52622C13.1417 8.81911 13.1417 9.29398 12.8488 9.58688L7.28032 15.1553C6.98743 15.4482 6.51256 15.4482 6.21966 15.1553Z"
    />
  </StyledSVG>
);

export default ChevronRight;
